import React, { Component, Fragment } from "react";
import BacktestService from "../../../../../../service/backtest.service";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import moment from "moment";
import CustomSelector from "../../../../../common/customSelectorOptions";
import CompareContent from "../../../../compare/compareContent";
import {
  modifyDataDrill,
  drillDownModify,
} from "../../../../compare/commonFunctions";
import Nav from "./navigation";
import ButtonGroup from "./buttonGroup";
import Comptab from "../../../../../PortfolioDashboard/navigationPages/Component page/component";
import Performance from "../../../../../PortfolioDashboard/navigationPages/performance/performance";
import Statistics from "../../../../../PortfolioDashboard/navigationPages/statistics/statistics";
import Simulation from "../../../../../PortfolioDashboard/navigationPages/simulation";
// import RebalanceDashboard from "../../../../../PortfolioDashboard/navigationPages/Rebalance/rebalance";
import NoDataAvailable from "../../../../../common/errorBoundary/noDataAvailable";
import Spinner from "../../../../../common/spinner";
// import WithCard from "../../../../../common/withCard";
import {
  StyleSheet,
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf,
} from "@react-pdf/renderer";
import {
  pdfStyles,
  pdfcolors,
} from "../../../../../PortfolioDashboard/navigationPages/Component page/pdf.styles";
import PdfHeader from "../../../../../parts/pdfmaker/common/pdfHeader";
import PdfTable from "../../../../../parts/pdfmaker/common/pdfTable-BuySell";
import PDFHelper from "../../../../../parts/pdfmaker/pdf.helper";
import Helper from "../../../../../pages/helper.current_buy_sell";
import helper from "../../../../helper.modifyPortfolio";
// import Montecarlo from "./navigation/Montecarlo/Montecarlo";
import "./AnalyzeAnalysis.styles.scss";

class AnalyzeAnalysis extends Component {
  state = {
    environment: "",
    getBacktest: {},
    getPerfHistMetrics: [],
    filteredObjects: [],
    columns: [{ title: "Symbol" }, { title: "Weight" }],
    ErrorLoadingData: false,
    responseId: 0,
    error: false,
    loading: false,
    defaultSelectOption: "",
    selectTypeData: [],
    activeSelectTypeData: [],
    origOBJ: [],
    getDataSpinner: false,
    reRender_statistics_tab: false,
    step: 0,
    pdfTableHeading: [
      { title: "YOUR Portfolio" },
      { title: "Weight (%)" },
      { title: "IQCIO Portfolio" },
      { title: "Weight (%)" },
      { title: "Recommendation" },
    ],
    yourPortfolioApiCall: false,
    iqcioPortfolioApiCall: false,
    getRiskStatistics: [],
    last_dt: "",
  };

  componentWillMount() {
    // getting environment

    let environment = process.env.NODE_ENV;
    this.setState({
      environment,
    });
    const {
      compare_portfolio_id_analyze,
      model_id,
      list_of_myPortfolios,
    } = this.props;

    if (compare_portfolio_id_analyze === 0) {
      this.setDefaultListOptions(this.props);
      this.testAPI();
    }

    // call based on model_id
    this.getData(model_id * 1);

    // setting myPortfolio selection option data
    // if (list_of_myPortfolios) {
    //   this.myPortfolioModifyData({ data: list_of_myPortfolios });
    // }
  }
  componentDidMount() {
    this.props.setTableHead(this.state.columns);
    // this.modelChangeHandler({ active: "predefined" });
  }
  componentWillReceiveProps(nextProps) {
    const { list_of_myPortfolios } = nextProps;
    this.setDefaultListOptions(nextProps);

    // setting myPortfolio selection option data
    // if (list_of_myPortfolios) {
    //   this.myPortfolioModifyData({ data: list_of_myPortfolios });
    // }
  }

  setDefaultListOptions = (props) => {
    const {
      modelportfolios,
      model_id,
      setUniverseLiteModelName,
      selected_predefined_model,
      list_of_myPortfolios,
      model_name,
      iqcio_model_list,
      my_portfolio_list,
    } = props;

    // predefined models list
    // if (
    //   preDefinedModelActive &&
    //   modelportfolios &&
    //   modelportfolios.length > 0
    // ) {
    //   let arr = [];
    //   for (let i = 0; i < modelportfolios.length; i++) {
    //     let obj = {};
    //     obj[modelportfolios[i]["id"]] = modelportfolios[i]["data"][0][
    //       "scenario_name"
    //     ]
    //       ? modelportfolios[i]["data"][0]["scenario_name"]
    //       : modelportfolios[i]["data"][0]["benchmark"];
    //     arr.push(obj);
    //   }
    //   this.setState({
    //     selectTypeData: arr,
    //     // activeSelectTypeData: arr,
    //   });

    //   let defaultSelectOption = "";
    //   let filter =
    //     arr.length > 0 ? arr.filter((e, i) => Object.keys(e) == model_id) : [];
    //   if (arr.length > 0 && model_id && filter.length > 0) {
    //     defaultSelectOption = Object.values(
    //       arr.filter((e) => Object.keys(e) == model_id)[0]
    //     )[0];
    //   }

    //   if (selected_predefined_model == "iqcioModel") {
    //     this.setState({
    //       activeSelectTypeData: arr,
    //     });
    //   }
    // this.setState({
    //   defaultSelectOption,
    // });
    // setUniverseLiteModelName(defaultSelectOption);
    // }

    // myPortfolios list
    // if (
    //   list_of_myPortfolios &&
    //   list_of_myPortfolios.length > 0 &&
    //   (myPortfolioSelectionList.length == 0 ||
    //     selected_predefined_model == "myPortfolio")
    // ) {
    //   if (!list_of_myPortfolios) return;
    //   let arr = [];
    //   for (let i = 0; i < list_of_myPortfolios.length; i++) {
    //     let obj = {};
    //     if (list_of_myPortfolios[i]["scenario_name"]) {
    //       obj[list_of_myPortfolios[i]["scenario_id"]] =
    //         list_of_myPortfolios[i]["scenario_name"];
    //       arr.push(obj);
    //     }
    //   }
    //   this.setState({
    //     myPortfolioSelectionList: arr,
    //   });
    //   if (selected_predefined_model == "myPortfolio") {
    //     this.setState({
    //       activeSelectTypeData: arr,
    //     });
    //   }
    // }

    if (
      iqcio_model_list &&
      iqcio_model_list.length &&
      my_portfolio_list &&
      my_portfolio_list.length
    ) {
      this.setState({
        activeSelectTypeData:
          selected_predefined_model == "iqcioModel"
            ? iqcio_model_list
            : my_portfolio_list,
      });
    }
    // setUniverseLiteModelName(model_name);
  };

  backStepNav = () => {
    this.props.previousStep();
  };

  testAPI = (ID, client_portfolio_id) => {
        this.setState({
          yourPortfolioApiCall: true,
        });
    const { portfolio, historical_returns, model_id } = this.props;

    let secenario_id = ID ? ID : model_id;
    let obj = {};
    if (portfolio.length > 0) {
      for (let i = 0; i < portfolio.length; i++) {
        let num = portfolio[i]["val"] / 100;
        obj[portfolio[i]["symbol"]] = num.toFixed(2).toString();
      }
      delete obj[""];
    }

    let filtered_historical_return = [];
    if (historical_returns.length) {
      for (let i = 0; i < historical_returns.length; i++) {
        let obj = {};
        obj["date"] = historical_returns[i]["date"];
        obj["returns"] = historical_returns[i]["returns"];
        filtered_historical_return.push(obj);
      }
    }
    var temp = {
      weights: obj,
      alternative: false,
      model_id: secenario_id,
      client_portfolio_id: client_portfolio_id
        ? client_portfolio_id.toString()
        : "",
      historical_returns: filtered_historical_return,
    };

    let _user = window.localStorage.getItem("_user");
    if (_user) {
      _user = JSON.parse(_user);
    }
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = () => {
      if (xmlHttp.readyState === 4) {
        if (xmlHttp.status === 200) {
          this.setState({
            responseId: xmlHttp.responseText,
            loading: false,
          });
          console.log(xmlHttp.responseText);
          let portfolio_id = xmlHttp.responseText;
          if(client_portfolio_id){
              portfolio_id = client_portfolio_id*1;
          }
//          if (client_portfolio_id) {
//            this.props.setComparePortfolioAnalyzeID(client_portfolio_id);
//            // this.get_data_after_client_ID(ID);
//            let origOBJ = {
//              scenario_id: client_portfolio_id,
//              benchmark: "",
//              type: "BACKTEST",
//            };
//            this.setState({
//              origOBJ,
//            });
//            this.get_data_after_client_ID(client_portfolio_id*1);
//            this.getRiskStatisticsData(client_portfolio_id*1);
//            this.getPerfHistmetricsData(client_portfolio_id*1);
//          } else {
            this.props.setComparePortfolioAnalyzeID(portfolio_id);
            this.get_data_after_client_ID(portfolio_id);
            this.getRiskStatisticsData(portfolio_id);
            this.getPerfHistmetricsData(portfolio_id);
            let origOBJ = {
              scenario_id: xmlHttp.responseText,
              benchmark: "DUMMY",
              type: "BACKTEST",
            };
            this.setState({
              origOBJ,
            });
//          }
        } else {
          this.setState({
            error: true,
            ErrorLoadingData: true,
          });
        }
      }
    };
    xmlHttp.open(
      "post",
      "https://api.iqcioadvisers.com/ajax_compare_portfolio/"
    );
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.setRequestHeader("Authorization", "Bearer " + _user.token);
    xmlHttp.send(JSON.stringify(temp));
  };

  getData = async (prop) => {
    // setting iqcio portfolio data
    const { setIqTableData, setIQChartOption, setIQDrillData } = this.props;
    this.setState({
      getDataSpinner: true,
      iqcioPortfolioApiCall: true,
    });
    let id = Number(prop);

    if (id !== 0) {
      try {
        await BacktestService.getBacktest(`${id}`, "DUMMY", "BACKTEST").then(
          (res) => {
            if (res) {
              let last_dt = "";
              if (res.getPortfolioData) {
                // on first render setting yourPortfolio data to getPortfolioData & iqcio optimized to getBenchmarkData
                // on changing portfolio from drop down
                // your portfolio remains same initial data but iqcio optimized changing to getPortfolioData
                let data = res.getPortfolioData;
                // if (analyzeAnalysis_select_option_changed === false) {
                //   data = res.getBenchmarkData;
                // } else if (analyzeAnalysis_select_option_changed === true) {
                //   data = res.getPortfolioData;
                // }

                var mostRecentDate = moment(
                  Math.max.apply(
                    null,
                    data.map((e) => {
                      return moment(e.dt);
                    })
                  )
                ).format("YYYY-MM-DD");

                let formatedDate = moment(mostRecentDate).format("YYYY-MM-DD");

                var filteredObjects = data.filter(function (e) {
                  return e.dt === `${formatedDate}`;
                });
                var title = [],
                  value = [],
                  optimizedTable = [];
                filteredObjects.forEach((d) => {
                  title.push(d["fund_name"]);
                  value.push(d["allocation"] * 1);
                  optimizedTable.push([
                    `${d.fund_asset_class_focus} - ${d.fund_name}`,
                    +d.allocation,
                  ]);
                });

                var chartData2 = modifyDataDrill(filteredObjects);
                setIQDrillData(chartData2);
                var chartOptions2 = drillDownModify(filteredObjects);
                setIQChartOption(chartOptions2);
                setIqTableData(optimizedTable);

                this.props.setAnalyseIQCIOPortfolio(
                  chartOptions2,
                  chartData2,
                  optimizedTable
                );

                if (data && data.length) {
                  last_dt = data[data.length - 1]["dt"];
                }
              }

              this.setState({
                getBacktest: res,
                filteredObjects,
                iqcioPieTitle: title,
                iqcioPieValue: value,
                Spinner: false,
                SpinnerPie1: false,
                ErrorLoadingData: false,
                getDataSpinner: false,
                iqcioPortfolioApiCall: false,
                last_dt,
              });
            }
          }
        );

        await BacktestService.getPerfHistMetrics(`${id}`, "BACKTEST").then(
          (res) => {
            if (res) {
              this.setState({
                getPerfHistMetrics: res,
              });
            }
          }
        );

        // iqcio optimized risk statistics data fetching
        await BacktestService.getRiskStatistics(`${id}`, `BACKTEST`).then(
          (res) => {
            if (res) {
              this.setState({
                getRiskStatistics: res,
              });
            }
          }
        );
      } catch (err) {
        this.setState({
          ErrorLoadingData: true,
          getDataSpinner: false,
          iqcioPortfolioApiCall: false,
        });
        console.log(err);
      }
    }
  };

  get_data_after_client_ID = async (ID) => {
    // set only your portfolio data
    const { setYourTableData, setYourDrillData, setYrChartOption } = this.props;
    let id = Number(ID);
    this.setState({
      yourPortfolioApiCall: true,
    });
    try {
      await BacktestService.getBacktest(`${id}`, "DUMMY", "BACKTEST").then(
        (res) => {
          if (res) {
            let last_dt = "";
            if (res.getPortfolioData) {
              let data = res.getPortfolioData;
              let recentDate = moment(
                Math.max.apply(
                  null,
                  data.map((e) => {
                    return moment(e.dt);
                  })
                )
              ).format("YYYY-MM-DD");

              let formatedDate = moment(recentDate).format("YYYY-MM-DD");

              let filteredObj = data.filter(function (e) {
                return e.dt === `${formatedDate}`;
              });
              let t = [],
                v = [],
                yourTable = [];
              filteredObj.forEach((d) => {
                t.push(d["fund_name"]);
                v.push(d["allocation"] * 1);
                yourTable.push([
                  `${d.fund_asset_class_focus} - ${d.fund_name}`,
                  +d.allocation,
                ]);
              });

              setYourTableData(yourTable);
              let chartData = modifyDataDrill(filteredObj);
              setYourDrillData(chartData);
              let chartOptions = drillDownModify(filteredObj);
              setYrChartOption(chartOptions);

              this.props.setAnalyseYourPortfolio(
                chartOptions,
                chartData,
                yourTable
              );
              if (data && data.length) {
                last_dt = data[data.length - 1]["dt"];
              }
            }
            this.props.setClientBacktestData(res);
            this.setState({
              yourPortfolioApiCall: false,
              last_dt,
            });
          }
        }
      );
    } catch (err) {
      this.setState({
        ErrorLoadingData: true,
        yourPortfolioApiCall: false,
      });
    }
  };

  getRiskStatisticsData = async (id) => {
    await BacktestService.getRiskStatistics(`${id}`, `BACKTEST`).then((res) => {
      if (res) {
        this.props.setAnalyzeAnalysisRiskStatistics(res);
      }
    });
  };

  getPerfHistmetricsData = async (id) => {
    await BacktestService.getPerfHistMetrics(`${id}`, `BACKTEST`).then(
      (res) => {
        if (res) {
          this.props.setAnalyzeAnalysisPerfHistmetrics(res);
          this.setState({
            reRender_statistics_tab: true,
          });

          setTimeout(
            () =>
              this.setState({
                reRender_statistics_tab: false,
              }),
            0
          );
        }
      }
    );
    this.forceUpdate();
  };
  navToDashboard = () => {
    const { defaultSelectOption } = this.state;
    browserHistory.push({
      pathname: "/dashboard",
      state: {
        foo: parseInt("4173"),
        benchmark: "DUMMY",
        type: "BACKTEST",
        typeName: "IQCIO Model",
        headingName: `YOUR PORTFOLIO Vs ${defaultSelectOption}`,
      },
    });
  };

  selectDropDownHandler = ({ name, id, index, myPortfolio = false }) => {
    const {
      setUniverseLiteModelId,
      setActiveGoal,
      setBenchmarkName,
      setPortfolioID,
      modelportfolios,
      compare_portfolio_id_analyze,
      setAnalyseIQCIOPortfolio,
      setAnalyseYourPortfolio,
      setUniverseLiteModelName,
      setDirectReviewModelPortfolio,
      list_of_myPortfolios,
      selected_predefined_model,
      setModelPortfolios,
    } = this.props;

    setAnalyseIQCIOPortfolio([], [], []);
    setAnalyseYourPortfolio([],[],[]);
    setTimeout(() => this.testAPI(id, compare_portfolio_id_analyze * 1), 0);
    // getting data to iqcio optimized
    setTimeout(() => this.getData(id * 1), 0);

    setUniverseLiteModelId(id);
    setUniverseLiteModelName(name);

    this.setState({
      defaultSelectOption: name,
    });

    if (selected_predefined_model == "iqcioModel" && myPortfolio == false) {
      setModelPortfolios(modelportfolios);
      setActiveGoal(modelportfolios[index]);
      setBenchmarkName(modelportfolios[index].data[0].benchmark_name);
      setPortfolioID(id);
    } else if (
      selected_predefined_model == "myPortfolio" &&
      list_of_myPortfolios &&
      list_of_myPortfolios.length
    ) {
      let filtered_data = list_of_myPortfolios.filter(
        (e) => e.scenario_id == id
      );
      let condition = filtered_data.length > 0;
      let optimization_params = condition
        ? {
            [id]: {
              benchmark: filtered_data[0]["benchmark"],
              max_beta: filtered_data[0]["beta"],
              max_vol: filtered_data[0]["max_vol"],
              min_return: filtered_data[0]["min_return"],
              upper_bounds: filtered_data[0]["upper_bounds"],
            },
          }
        : {};
      //
      let asset_class = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["fund_asset_class_focus"],
          })
        : [];
      let fund_type = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["fund_type"],
          })
        : [];
      let overall_focus = condition
        ? helper.modify_backtest_params({
            data: filtered_data[0]["overall_focus"],
          })
        : [];
      let styles = condition
        ? helper.modify_backtest_params({
            name: "style",
            data: filtered_data[0]["style"],
          })
        : [];

      setDirectReviewModelPortfolio({
        activePortfolioID: id,
        optimization_params,
        benchmark_name: filtered_data[0]["benchmark_name"],
        asset_class,
        fund_type,
        overall_focus,
        styles,
      });
    }
  };
  optimizeMyUniverseHandler = () => {
    this.props.setActiveOptimizeUsingMyUniverse(true);

    setTimeout(() => this.props.nextStepCallBack(true), 200);
  };

  modelChangeHandler = ({ active }) => {
    const {
      modelportfolios,
      list_of_myPortfolios,
      iqcio_model_list,
      my_portfolio_list,
      setUniverseLitePreDefinedModelSelected,
    } = this.props;
    if (active == "predefined") {
      // setting pre-defined model active
      let name = modelportfolios[0]["data"][0]["scenario_name"];
      setUniverseLitePreDefinedModelSelected("iqcioModel");
      this.setState(
        {
          activeSelectTypeData: iqcio_model_list,
          defaultSelectOption: name,
        },
        () => {
          let id = modelportfolios[0]["id"];
          let index = 0;
          // stoped default chnages to 1st portfolio on changing model type
          // this.selectDropDownHandler({ name, id, index, myPortfolio: false });
        }
      );
    } else {
      // setting myPortfolio model active
      let name = list_of_myPortfolios[0]["scenario_name"];
      let id = list_of_myPortfolios[0]["scenario_id"];
      setUniverseLitePreDefinedModelSelected("myPortfolio");
      this.setState(
        {
          activeSelectTypeData: my_portfolio_list,
          defaultSelectOption: list_of_myPortfolios[0]["scenario_name"],
        },
        () => {
          let index = 0;
          // stoped default chnages to 1st portfolio on changing model type
          // this.selectDropDownHandler({ name, id, index });
        }
      );
    }
  };
  // -----pdf------
  exportToPDF = () => {
    // setTimeout(() => this.getAllBlobImages(), 500);
    const { yourDrilldown, iqcioDrilldown } = this.props;
    const styles = StyleSheet.create({
      ...pdfStyles,
    });
    const buy_sell_table_data = Helper.tableData(yourDrilldown, iqcioDrilldown);

    Promise.all([
      PDFHelper.svgToPng("drill1"),
      PDFHelper.svgToPng("drill2"),
    ]).then((values) => {
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap style={styles.pb}>
            <PdfHeader />
            <View
              style={{
                color: "#223279",
                textAlign: "center",
                paddingTop: 5,
              }}
            >
              <Text>
                Comparision of the uploaded portfolio vs{" "}
                {this.state.defaultSelectOption} model.
              </Text>
            </View>
            <View style={{ paddingHorizontal: 5 }}>
              <View
                style={{
                  color: "#223279",
                  textAlign: "center",
                  paddingTop: 5,
                }}
              >
                <Text>YOUR PORTFOLIO</Text>
              </View>
              <View>
                <IMG source={values[0]}></IMG>
              </View>
            </View>
          </Page>
          <Page size="A4" wrap style={{ paddingHorizontal: 10 }}>
            <View style={{ paddingHorizontal: 10 }}>
              <View
                style={{
                  color: "#223279",
                  textAlign: "center",
                  paddingTop: 5,
                }}
              >
                <Text>IQCIO PORTFOLIO</Text>
              </View>
              <View>
                <IMG source={values[1]}></IMG>
              </View>
            </View>
          </Page>
          <Page
            size="A4"
            wrap
            style={{ paddingHorizontal: 10, paddingTop: 10 }}
          >
            <PdfTable
              heading={this.state.pdfTableHeading}
              data={buy_sell_table_data}
            />
          </Page>
        </Document>
      );

      pdf(<MyDoc />)
        .toBlob()
        .then((blob) => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "sample.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };
  setStepNumber = (event) => {
    let id = event.target.getAttribute("data-id");
    if (id === "#c1") {
      this.setState({
        step: 0,
      });
    } else {
      this.setState({
        step: this.state.step + 1,
      });
    }
  };

  // ---------------
  render() {
    const {
      environment,
      columns,
      ErrorLoadingData,
      defaultSelectOption,
      activeSelectTypeData,
      getBacktest,
      getPerfHistMetrics,
      getDataSpinner,
      reRender_statistics_tab,
      buy_sell_heading,
      yourPortfolioApiCall,
      iqcioPortfolioApiCall,
      last_dt,
    } = this.state;
    const {
      active_optimize_using_myUniverse,
      model_id,
      compare_portfolio_id_analyze,
      // analyzeAnalysis_select_option_changed,
      yourTable,
      yourChartOptions,
      yourDrilldown,
      iqcioChartOptions,
      iqcioDrilldown,
      iqcioTable,
      list_of_myPortfolios,
      modelportfolios,
      model_name,
      selected_predefined_model,
      analyzeExistingActive,
    } = this.props;

    let scenarioID;

    // if (analyzeAnalysis_select_option_changed) {
    scenarioID = Number(this.props.model_id);
    // } else {
    //   scenarioID = compare_portfolio_id_analyze;
    // }
    return (
      <div className="analyze-analysis">
        <Nav
          block={
            (yourDrilldown && yourDrilldown.length == 0) ||
            (iqcioDrilldown && iqcioDrilldown.length == 0) ||
            ErrorLoadingData
              ? true
              : false
          }
          setStepNumber={this.setStepNumber}
          comparePdfButton={this.state.step == 0 ? true : false}
          downloadPdfHandler={this.exportToPDF}
        />

        <div className="tab-content">
          <div id="c1" className="tab-pane fade in active">
            <div className="analyze-analysis_heading">
              <div>
                <div className="analyze-analysis_heading_txt1">
                  Comparison of the uploaded portfolio vs {model_name} model.
                </div>
                <span className="analyze-analysis_heading_txt2">
                  You can compare against a different model from the dropdown
                </span>
              </div>
              <div>
                {/* {modelportfolios.length && list_of_myPortfolios.length ? (
                  <div className="analyze-analysis_model_options">
                    <div
                      className={
                        this.state.preDefinedModelActive
                          ? "analyze-analysis_model_options_active"
                          : ""
                      }
                      onClick={() =>
                        this.modelChangeHandler({ active: "predefined" })
                      }
                    >
                      Pre-defined Model
                    </div>
                    <div
                      className={
                        !this.state.preDefinedModelActive
                          ? "analyze-analysis_model_options_active"
                          : ""
                      }
                      onClick={() =>
                        this.modelChangeHandler({ active: "modelPortfolio" })
                      }
                    >
                      MyPortfolio Model
                    </div>
                  </div>
                ) : null} */}
                {activeSelectTypeData && activeSelectTypeData.length > 0 ? (
                  <CustomSelector
                    textAlign={"left"}
                    defaultText={model_name}
                    optionsList={activeSelectTypeData}
                    changeHandler={(e) => this.selectDropDownHandler(e)}
                    showDifferentModels={true}
                    iqcioModelHandler={() =>
                      this.modelChangeHandler({ active: "predefined" })
                    }
                    myPortfolioModelHandler={() =>
                      this.modelChangeHandler({ active: "modelPortfolio" })
                    }
                    model={selected_predefined_model}
                  />
                ) : (
                  <div style={{ paddingRight: "50px" }}>
                    <Spinner />
                  </div>
                )}
              </div>
            </div>
            <CompareContent
              yourDrilldown={yourDrilldown}
              yourChartOptions={yourChartOptions}
              yourTable={yourTable}
              iqcioDrilldown={iqcioDrilldown}
              iqcioChartOptions={iqcioChartOptions}
              optimizedTable={iqcioTable}
              columns={columns}
              id={"drill1"}
              idIn={"drill_content1"}
              id2={"drill2"}
              idIn2={"drill_content2"}
              ErrorLoadingData={
                getDataSpinner == false && ErrorLoadingData == true
                  ? true
                  : false
              }
              buySellTable={true}
              yourPortfolioApiCall={yourPortfolioApiCall}
              iqcioPortfolioApiCall={iqcioPortfolioApiCall}
              heading={"Create Portfolio"}
            />
          </div>
          <div id="c2" className="tab-pane fade in">
            {Object.keys(getBacktest).length ? (
              <Comptab
                scenario_id={scenarioID}
                getBacktest={getBacktest}
                heading={"Create Portfolio"}
              />
            ) : null}
            <Fragment>{getDataSpinner ? <Spinner /> : null}</Fragment>
            {ErrorLoadingData ? <NoDataAvailable /> : null}
          </div>
          <div id="c3" className="tab-pane fade in">
            {Object.keys(getBacktest).length &&
            getPerfHistMetrics.length > 0 &&
            this.state.getRiskStatistics &&
            this.state.getRiskStatistics.length > 0 ? (
              <Performance
                scenario_id={scenarioID}
                getBacktest={getBacktest}
                getPerfHistMetrics={getPerfHistMetrics}
                benchmark="DUMMY"
                type="BACKTEST"
                foo={scenarioID}
                origOBJ={this.state.origOBJ}
                orig_lineChart_data={"portfolio"}
                typeName="IQCIO Model"
                getRiskStatistics={this.state.getRiskStatistics}
                heading={"Create Portfolio"}
              />
            ) : null}
            <Fragment>{getDataSpinner ? <Spinner /> : null}</Fragment>
            {ErrorLoadingData || getPerfHistMetrics.length === 0 ? (
              <NoDataAvailable />
            ) : null}
          </div>
          <div id="c4" className="tab-pane fade in">
            {(this.state.getRiskStatistics &&
              this.state.getRiskStatistics.length > 0 &&
              Object.keys(getBacktest).length) ||
            reRender_statistics_tab ? (
              <Statistics
                scenario_id={scenarioID}
                getBacktest={getBacktest}
                getPerfHistMetrics={getPerfHistMetrics}
                lastTableDisplay={true}
                benchmark="DUMMY"
                type="BACKTEST"
                foo={scenarioID}
                origOBJ={this.state.origOBJ}
                checkORIG_Present={true}
                typeName="IQCIO Model"
                getRiskStatistics={this.state.getRiskStatistics}
                heading={"Create Portfolio"}
              />
            ) : null}
            <Fragment>{getDataSpinner ? <Spinner /> : null}</Fragment>
            {ErrorLoadingData ? <NoDataAvailable /> : null}
          </div>
            {/*{environment !== "production" ? (*/}
            <div id="c5" className="tab-pane fade in">
              {scenarioID && last_dt && this.props.compare_portfolio_id_analyze ? (
                <Simulation
                  scenarioID={scenarioID}
                  dt={last_dt}
                  getBacktest={getBacktest}
                  type="BACKTEST"
                  heading={"Create Portfolio"}
                  analyzeExistingActive={analyzeExistingActive}
                  clientPortfolioID={this.props.compare_portfolio_id_analyze}
                />
              ) : null}
            </div>
          {/*}) : null}*/}
          {/* <div id="c6" className="tab-pane fade in">
            {Object.keys(getBacktest).length > 0 ? (
              <RebalanceDashboard
                scenario_id={scenarioID}
                getBacktest={getBacktest}
                getPerfHistMetrics={getPerfHistMetrics}
                benchmark="DUMMY"
                type="BACKTEST"
                foo={scenarioID}
              />
            ) : null}
            <Fragment>{getDataSpinner ? <Spinner /> : null}</Fragment>
            {(ErrorLoadingData && getDataSpinner == false) ||
            Object.keys(getBacktest).length == 0 ? (
              <NoDataAvailable />
            ) : null}
          </div> */}
        </div>
        <ButtonGroup
          backStepNav={this.backStepNav}
          // navToDashboard={this.navToDashboard}
          optimizeMyUniverseHandler={this.optimizeMyUniverseHandler}
        />
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      modelportfolios,
      steps: {
        universeLite: {
          portfolio,
          historical_returns,
          model_id,
          model_name,
          active_optimize_using_myUniverse,
          compare_portfolio_id_analyze,
          analyzeExistingActive,
          analyze_compare: {
            yourTable,
            yourChartOptions,
            yourDrilldown,
            iqcioChartOptions,
            iqcioDrilldown,
            iqcioTable,
            clientBacktestData,
          },
          predefined_models: {
            selected_predefined_model,
            iqcio_model_list,
            my_portfolio_list,
          },
        },
        risk: { display_orig_portfolio },
      },
    },
    myPortfolios: { list_of_myPortfolios },
  }) => ({
    modelportfolios,
    portfolio,
    historical_returns,
    model_id,
    model_name,
    active_optimize_using_myUniverse,
    compare_portfolio_id_analyze,
    yourTable,
    yourChartOptions,
    yourDrilldown,
    iqcioChartOptions,
    iqcioDrilldown,
    iqcioTable,
    analyzeExistingActive,
    clientBacktestData,
    display_orig_portfolio,
    list_of_myPortfolios,
    selected_predefined_model,
    iqcio_model_list,
    my_portfolio_list,
  }),
  (dispatch) => ({
    setUniverseLiteModelId: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_MODEL_ID",
        payload,
      }),
    setUniverseLiteModelName: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_MODEL_NAME",
        payload,
      }),
    // updating date in to redux create portfolio object flow so we can update in compare dashboard aswell
    setTableHead: (payload) =>
      dispatch({ type: "COMPARE_PORTFOLIO_TABLE_HEAD", payload }),
    setYourTableData: (payload) =>
      dispatch({ type: "SET_YOURTABLE_DATA", payload }),
    setIqTableData: (payload) =>
      dispatch({ type: "SET_IQTABLE_DATA", payload }),
    setYourDrillData: (payload) =>
      dispatch({ type: "SET_YOURDRILLDOWN", payload }),
    setIQDrillData: (payload) => dispatch({ type: "SET_IQDRILLDOWN", payload }),
    setYrChartOption: (payload) =>
      dispatch({ type: "SET_YR_CHARTOPTION", payload }),
    setIQChartOption: (payload) =>
      dispatch({ type: "SET_IQ_CHARTOPTION", payload }),
    setActiveOptimizeUsingMyUniverse: (payload) =>
      dispatch({
        type: "SET_ACTIVE_OPTIMIZE_USING_MYUNIVERSE",
        payload,
      }),
    setAnalyseYourPortfolio: (yourChartOptions, yourDrilldown, yourTable) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_COMPARE_YOUR_PORTFOLIOS",
        payload: { yourChartOptions, yourDrilldown, yourTable },
      }),

    setAnalyseIQCIOPortfolio: (iqcioChartOptions, iqcioDrilldown, iqcioTable) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_COMPARE_IQCIO_PORTFOLIOS",
        payload: { iqcioChartOptions, iqcioDrilldown, iqcioTable },
      }),

    // setting compare portfolio analyze id
    setComparePortfolioAnalyzeID: (payload) =>
      dispatch({ type: "SET_COMPARE_PORTFOLIO_ID_ANALYZE", payload }),
    setPortfolioID: (payload) =>
      dispatch({ type: "SET_PORTFOLIO_ID", payload }),
    setActiveGoal: (inv) => dispatch({ type: "SET_ACTIVE_GOAL", payload: inv }),
    setBenchmarkName: (payload) =>
      dispatch({ type: "SET_BENCHMARKNAME", payload }),
    setClientBacktestData: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_CLIENT_BACKTEST_DATA",
        payload,
      }),
    setAnalyzeAnalysisRiskStatistics: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_RISK_STATISTICS",
        payload,
      }),
    setAnalyzeAnalysisPerfHistmetrics: (payload) =>
      dispatch({
        type: "SET_ANALYZE_ANALYSIS_PERF_HISTMETRICS",
        payload,
      }),
    setDirectReviewModelPortfolio: (payload) =>
      dispatch({ type: "SET_DIRECT_REVIEW_PORTFOLIO_MODELPORTFOLIO", payload }),
    setModelPortfolios: (modelportfolios) =>
      dispatch({ type: "SET_PORTFOLIOS", payload: modelportfolios }),
    setUniverseLitePreDefinedModelSelected: (payload) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_PRE_DEFINED_MODEL_SELECTED",
        payload,
      }),
  })
)(AnalyzeAnalysis);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/AnalyzeAnalysis.jsx